export const getRecommendation = ({
  recommendation,
  normalizedValue,
  value: { notApplicable },
  question: { normalizedThreshold }
}) => {
  if (notApplicable) {
    return {
      text: 'N/A',
      score: null
    }
  } else if (normalizedValue >= normalizedThreshold) {
    return {
      text: recommendation.above,
      score: recommendation.stage.scale
    }
  } else {
    return {
      text: recommendation.bellow,
      score: recommendation.stage.scale < 2 ? 0 : -(recommendation.stage.scale - 1)
    }
  }
}

export default getRecommendation
